export default function spaceint2(x) {
  if (x == null || x == undefined) {
    return "-";
  }
  var parts = x.toString().split(".");
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, " ");
  return parts.join(".");
}
